import { AccessGrant, Mutation } from 'graphql/generated/graphqlTypes';
import { generateMockAccessGrant } from 'mocks/graphqlMocks/accessGrant';

export function mockedSetIsAdminForGroup(
  accessGrant: AccessGrant
): Pick<Mutation, 'setAccessGrantsIsOfficeModeEnabled'> {
  return {
    setAccessGrantsIsOfficeModeEnabled: accessGrant
  };
}

export const mockedUpdateAccessGrantWithIsOfficeModeForMutation1 = mockedSetIsAdminForGroup(
  generateMockAccessGrant({ id: 'mockedGrantId' })
);
